var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('div',{staticStyle:{"direction":"rtl"}},[_vm._v("زدایندکس")]),_c('el-input',{attrs:{"dir":"ltr","placeholder":"z-index","type":"number"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }